import {
    registerAsset,
    registerAssetCommandsByType,
    AssetAriaLabel,
    showQuickOptions,
    DEFAULT_MIN_ASSET_WIDTH,
    GRID_SIZE,
} from 'owa-timestream-asset-sdk';
import { DefaultCommand } from 'owa-timestream-asset-sdk-types';
import WeatherTemperatureUnit from 'owa-service/lib/contract/WeatherTemperatureUnit';
import type { WeatherPayload } from './schema';
import {
    weatherAssetName,
    assetErrorWeather,
    weatherAssetTooltip,
    weatherAssetDegreesCelsius,
    weatherAssetDegreesFahrenheit,
    temperatureCommandName,
} from './weather.locstring.json';
import WeatherView from './components/WeatherView';
import type LocationCommonWellItemViewState from 'owa-location-common-well/lib/store/schema/LocationCommonWellItemViewState';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { isFeatureEnabled } from 'owa-feature-flags';

const WEATHER_TYPE = 'weather';

export default registerAsset<WeatherPayload>({
    type: WEATHER_TYPE,
    iconName: ControlIcons.PartlyCloudyDay,
    isAssetEnabled: () => isFeatureEnabled('cal-mf-calendarWeatherDetails'),
    getToolName: () => loc(weatherAssetName),
    getTooltip: () => loc(weatherAssetTooltip),
    getErrorMessage: () => loc(assetErrorWeather),
    unsupportedDefaultCommands: [DefaultCommand.DueDate],
    CanvasView: WeatherView,
    createEmptyAsset: () => ({
        type: WEATHER_TYPE,
        width: DEFAULT_MIN_ASSET_WIDTH + GRID_SIZE,
        payload: { selectedLocation: (null as unknown) as LocationCommonWellItemViewState },
    }),
    getAriaLabel: (payload: WeatherPayload) => {
        if (!payload.selectedLocation) {
            return loc(weatherAssetName);
        }
        return loc(
            AssetAriaLabel.assetAriaLabel,
            loc(weatherAssetName),
            getWeatherDescription(payload)
        );
    },
    getTitleString: getWeatherTitle,
    getSearchString: getWeatherTitle,
});

registerAssetCommandsByType('weather', [
    {
        id: 'changeTemperatureUnit',
        iconName: ControlIcons.Frigid,
        titleResourceId: temperatureCommandName,
        onInvoke: showQuickOptions,
    },
]);

function getWeatherTitle(payload: WeatherPayload) {
    return payload.selectedLocation?.persona?.displayName;
}

function getWeatherDescription(payload: WeatherPayload) {
    const degreesString =
        payload.tempUnit && payload.tempUnit === WeatherTemperatureUnit.Celsius
            ? weatherAssetDegreesCelsius
            : weatherAssetDegreesFahrenheit;
    return [getWeatherTitle(payload), loc(degreesString, payload.temp), payload.skyText].join(', ');
}
